import styled from "styled-components";

export const FactorSection = styled.section`
  .table-factor {
    width: 100%;
    border-collapse: inherit;
  }

  .table-factor td {
    text-align: center;
    padding: 0px 1px 0 0;
    height: auto;
  }

  .first-td-table-factor-detail div {
    transform: translate(-50%, -50%) rotate(90deg);
    font-size: 16px;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
  }
  
  .first-td-table-factor-detail {
    width: 64px;
    height: 75px !important;
    background-color: #eee;
    position: relative;
    border: 1px solid black;
  }

  .parrent-inf-first-table-factor {
    border: 1px solid black;
  }

  .table-factor table {
    width: 100%;
    border-collapse: inherit;
  }

  .table-factor table td {
    border: none;
    padding: 5px;
    font-size: 16px;
    text-align: right;
  }

  .table-factor-information {
    width: 100%;
    margin-top: 5px;
  }

  .table-factor-information th {
    font-weight: 400;
    background-color: #eee;
  }

  .table-factor-information th,
  .table-factor-information td {
    border: 1px solid black;
    padding: 5px;
    text-align: center;
  }

  .container-total-price-inf-factor-detail {
    width: 100%;
    position: relative;
  }

  .table-factor-information thead:first-child,
  .container-total-price-inf-factor-detail thead {
    background: #eee;
  }

  .container-total-price-inf-factor-detail td {
    padding: 10px 20px;
    border: 1px solid black;
    text-align: center;
  }

  .container-table-signature td {
    border: 1px solid #000;
    padding: 10px 15px;
    width: 50%;
    height: 160px;
    vertical-align: baseline;
  }

  .faramooz-sign-image-container {
    text-align: center;
  }

  .faramooz-sign-image {
    width: 200px;
    margin: 0 auto;
  }
`;
